module.exports = __webpack_public_path__ + "img/salesman-surfer@2x.ec83461e.png";